<!--
Considera pedidos de venda válidos (aberto ou faturado)


















FALTA FINALIZAR, MUDAR URL, COLUNAS DE VALORES 




-->


<template>
  <div class="default-container p-3"> 
    <filtro :showfiltro="showfiltro" :params="paramsFiltro" @change="filtroChange" @cancel="showfiltro=false"></filtro>

    <div class="row">
      <div class="col-12 lbl-deal-title mb-2">
        <span class="lbl-deal-title mb-2 w-100">COMISSÃO POR PEDIDO</span>
        <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-center">
      <div class="col-md-6 col-12">
        <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 lbl-title mb-2">
        PEDIDOS
        <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
              <table class="table table-striped table-hover responsive tablesorter w-100">
                  <thead>
                      <tr>
                        <template v-for="col in colunas">
                          <th v-if="col.visible" :class="col.class" :style="col.style">{{ col.label }}</th>
                        </template>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(row, index) in dados.items" :key="index">
                          <td v-if="colunas[0].visible" :style="colunas[0].style" :class="colunas[0].class">{{ row.npedido }}</td>
                          <td v-if="colunas[1].visible" :style="colunas[1].style" :class="colunas[1].class">{{ row.data | formatData }}</td>
                          <td v-if="colunas[2].visible" :style="colunas[2].style" :class="colunas[2].class">{{ row.razao }}</td>
                          <td v-if="colunas[3].visible" :style="colunas[3].style" :class="colunas[3].class">{{ row.cnpjcpf | formatCNPJCPF }}</td>
                          <td v-if="colunas[4].visible" :style="colunas[4].style" :class="colunas[4].class">{{ row.uf }}</td>
                          <td v-if="colunas[5].visible" :style="colunas[5].style" :class="colunas[5].class">{{ row.nome_usuario }}</td>
                          <td v-if="colunas[6].visible" :style="colunas[6].style" :class="colunas[6].class">{{ row.vendedor_nome }}</td>
                          <td v-if="colunas[7].visible" :style="colunas[7].style" :class="colunas[7].class">{{ row.total_pedido | formatValue(2) }}</td>
                          <td v-if="colunas[8].visible" :style="colunas[8].style" :class="colunas[8].class">{{ row.base_comissao | formatValue(2) }}</td>
                          <td v-if="colunas[9].visible" :style="colunas[9].style" :class="colunas[9].class">{{ row.total_comissao | formatValue(2) }}</td>
                          <td v-if="colunas[10].visible" :style="colunas[10].style" :class="colunas[10].class">{{ row.percentual_comissao | formatValue(2) }}</td>
                      </tr>
                  </tbody>
                  <tfoot>
                      <tr>
                          <th class="text-right total">Total</th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="numerico total">{{ dados.total.total_pedido | formatValue(2) }}</th>
                          <th class="numerico total">{{ dados.total.base_comissao | formatValue(2) }}</th>
                          <th class="numerico total">{{ dados.total.total_comissao | formatValue(2) }}</th>
                          <th class="numerico total"></th>
                      </tr>
                  </tfoot>
              </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashCard from "../dashboards/dash-card";
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost, apiORDS } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";

export default {
  components: {
    DashCard,
    Filtro,
    Chart,
  },

  data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        periodo: {
          label: "Data do pedido",
          varios: false,
          data_inicio: null,
          data_termino: null,
        },

        filtros: [
          {
            nome: "usuario",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "cliente",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
        ],
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }],
      },

      colunas: [
      ],

      nextPage: false,

    };
  },

  computed: {
    // paramsChart: function () {
    //   return { chart: { type: "ColumnChart" }, values: this.chartValues, colors: this.colors }
    // },

    // chartValues: function () {
    //   if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0)
    //     return []
    //   else
    //     return this.dadosGrafico.grafico
    // },
  },

  watch: {
      data_referencia: function () {
          this.loadData()
      },
  },

  methods: {

    clickRetornar () {
      this.$router.push('/')
    },

    montaColunas () {
        this.colunas = [
            { nome: 'pedido', visible: true, label: 'Número do Pedido', sortable: true, orderby: null, class: 'size130', style: '' },
            { nome: 'data', visible: true, label: 'Data do Pedido', sortable: true, orderby: null, class: 'size130', style: '' },
            { nome: 'razao', visible: true, label: 'Cliente', sortable: true, orderby: null, class: '', style: 'min-width: 280px;' },
            { nome: 'cnpjcpf', visible: true, label: 'Cnpj/Cpf', sortable: true, orderby: null, class: '', style: '' },
            { nome: 'uf', visible: true, label: 'Estado', sortable: true, orderby: null, class: '', style: '' },
            { nome: 'nome_usuario', visible: true, label: 'Usuario', sortable: true, orderby: null, class: '', style: 'min-width: 120px;' },
            { nome: 'vendedor_nome', visible: true, label: 'Vendedor', sortable: true, orderby: null, class: '', style: 'min-width: 120px;' },
            { nome: 'total_pedido', visible: true, label: 'Total do Pedido', sortable: false, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'base_comissao', visible: true, label: 'Base Comissão', sortable: false, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'total_comissao', visible: true, label: 'Total Comissão', sortable: false, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'percentual_comissao', visible: true, label: '% Comissão', sortable: false, orderby: null, class: 'numerico size130', style: '' },
        ]
    },

    handleShowFiltro() {
      this.showfiltro = true;
    },

    filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.usuario
      this.paramsFiltro.filtros[1].values = this.filtro.cliente

      this.loadData();
    },

    scroll () {
      window.onscroll = () => {
        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          this.loadData(false, true)
        }
        // SysVars.scrollPosition = document.documentElement.scrollTop
      }
    },

    async loadData(excel, loadMore) {

      let url = "consulta/vendas/vendascomissaoporpedido";
      // let url = "consulta/teste";

      if (loadMore)
        if (this.dados.has_more) {
          this.filtro.page = this.dados.next_page
          this.nextPage = true
        }
        else
          return

      this.filtro.excel = excel

      if (excel)
        apiDownload2(this, url, this.filtro, "post")
      else {
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (data) {
          if (loadMore) {
            this.dados.items.push(...data.items)
            this.dados.has_more = data.has_more
            this.dados.next_page = data.next_page
          }
          else
            this.dados = data
        } else {
          this.dados = {};
        }
        this.montaColunas()
      }

      let self = this
      this.$nextTick(function () {
        self.nextPage = false
      })

    },
  },

  mounted() {
    this.scroll()
  },

  destroyed () {
    window.onscroll = null
  },

  created() {
    this.filtro.periodos[0].data_inicio = "2018-02-01"
    this.filtro.periodos[0].data_termino = "2021-09-01"

    this.loadData()
  },
}


</script>

<style>

table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.resumo__performance {
  display: flex;
  align-items: center;
  justify-content: space-between;  
}

.resumo__performance__value {
    padding: 5px 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    border-radius: 10%;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-vendas-comissao-por-pedido.vue